import { ref } from 'vue'
import { defineStore } from 'pinia'
import { SalesLead } from '~/models/SalesLead'

export const useTripLeadStore = defineStore('tripLead', () => {
	const leads = ref<Record<string, SalesLead>>({})

	const setLead = (tripId: string, salesLead: SalesLead) => {
		leads.value[tripId] = salesLead
	}

	const getLead = (tripId: string): SalesLead | undefined => {
		return leads.value[tripId]
	}

	return {
		setLead,
		getLead,
	}
})
